module.exports = __webpack_public_path__ + "static/img/example-img.672c226b.png";